import { render, staticRenderFns } from "./OrgMemberSiteAccessList.vue?vue&type=template&id=317621b2&scoped=true&"
import script from "./OrgMemberSiteAccessList.vue?vue&type=script&lang=js&"
export * from "./OrgMemberSiteAccessList.vue?vue&type=script&lang=js&"
import style0 from "./OrgMemberSiteAccessList.vue?vue&type=style&index=0&id=317621b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317621b2",
  null
  
)

export default component.exports